import articlePage from "@faire/web-api/routes/support/articles/articleId";
export var WhyOrderCancelledIA = function WhyOrderCancelledIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    learnMoreLink: articles !== null && articles !== void 0 && articles.Account.NOT_OPEN ? articlePage(articles.Account.NOT_OPEN.id) : undefined
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return VERIFY_YOUR_ACCOUNT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [WE_VERIFY_ALL_NEW_ACCOUNTS(strictLocalize), IF_YOU_HAVE_ANY_QUESTIONS(strictLocalize)];
    }
  };
};
var VERIFY_YOUR_ACCOUNT = function VERIFY_YOUR_ACCOUNT(strictLocalize) {
  return strictLocalize({
    id: "JDvEit",
    defaultMessage: [{
      "type": 0,
      "value": "Les comptes doivent être vérifiés pour recevoir des commandes de marques sur Faire"
    }]
  });
};
var WE_VERIFY_ALL_NEW_ACCOUNTS = function WE_VERIFY_ALL_NEW_ACCOUNTS(strictLocalize) {
  return strictLocalize({
    id: "3HQ2jm",
    defaultMessage: [{
      "type": 0,
      "value": "Nous vérifions tous les nouveaux comptes afin de garantir la sécurité de notre plateforme. Si votre compte ne peut pas être vérifié, toutes les commandes existantes seront annulées. Aucun frais ne vous sera facturé."
    }]
  });
};
var IF_YOU_HAVE_ANY_QUESTIONS = function IF_YOU_HAVE_ANY_QUESTIONS(strictLocalize) {
  return strictLocalize({
    id: "WVf5FE",
    defaultMessage: [{
      "type": 0,
      "value": "Si vous avez des questions, contactez-nous et nous vous répondrons dès que possible."
    }]
  });
};